import React from "react";

const Loader = ({ height = "h-32", width = "w-32", color = "#F87315" }) => {
  return (
    <div className="flex items-center justify-center">
      <div
        className={`animate-spin rounded-full ${height} ${width} border-t-4 border-b-4 border-[${color}]`}
      ></div>
    </div>
  );
};

export default Loader;
